





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import PatientAcquisitionConditions from '@/components/patients/acquisition/PatientAcquisitionConditions.vue';

@Component({
  components: {
    PatientAcquisitionConditions,
  },
})
export default class PatientFileLastAnalysisInformations extends Vue {
  @Prop({ required: true }) private readonly patient!: TEntity<TPatient>;

  get haveAcquisition() {
    return this.patient.acquisitions ? this.patient.acquisitions.length : null;
  }
  get haveConditions() {
    const conditions = this.patient.acquisitions[0]?.conditions;
    let pains = null;
    let shoesType = null;
    let walkingAids = null;
    if (conditions) {
      pains = conditions.pains?.length;
      shoesType = conditions.shoes_type;
      walkingAids = conditions.walking_aids?.length;
    }
    return pains || shoesType || walkingAids;
  }

  showAnalysis() {
    this.$router.push({ path: `/patient/${this.patient._id}/result/${this.patient.acquisitions[0]._id}` });
  }
}
